import Vue from "vue";
import VueRouter from "vue-router";
import { storage } from "../utils/public";
import Login from "../views/login/index.vue";
const Admin = () => import("../views/admin/index.vue");
const ActivityList = () => import("../views/admin/activityList.vue");
const ActivityInfo = () => import("../views/admin/activityInfo.vue");
const OrderList = () => import("../views/admin/orderList.vue");
const NotFound = () => import("../views/errorPage/404.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login
  },
  {
    path: "/admin",
    component: Admin,
    beforeEnter: (to, from, next) => {
      const hasToken = storage.getSession("token");
      if (hasToken) {
        next();
      } else {
        next({ path: "/" });
      }
    },
    children: [
      {
        path: "",
        component: ActivityList,
        alias: "/activityList"
      },
      {
        path: "activityInfo/:type",
        component: ActivityInfo,
        alias: "/activityInfo/:type"
      },
      {
        path: "orderList",
        component: OrderList,
        alias: "/orderList"
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

export default router;
